//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";
import { mapState, mapActions } from "vuex";

import router from "../../router";
export default {
  data() {
    return {
      pagination: {
        page: 1,
        rowsPerPage: 15, // current rows per page being displayed
        sortBy: "orderNumber",
        descending: true,
        rowsNumber: 0
      },
      unfilteredOrders: [],
      orders: [],
      orderOptions: [
        { value: 100, name: this.$t("purchaseOrder.status-100") },
        { value: 200, name: this.$t("purchaseOrder.status-200") },
        { value: 300, name: this.$t("purchaseOrder.status-300") },
        { value: 400, name: this.$t("purchaseOrder.status-400") },
        { value: 500, name: this.$t("purchaseOrder.status-500") },
        { value: 600, name: this.$t("purchaseOrder.status-600") },
        { value: 700, name: this.$t("purchaseOrder.status-700") },
      ],
      orderStatuses: [],
      disableFilters: false,
      filter: "",
      departmentSelected: [],
      timerId: 0,
      customers: [],
      orderId: 0,
      disableNewPurchase: false,
      title: this.$t("headers.purchaseOrder"),

      dense: true,
      nodatalabel: "",
      visibleColumns: [ 
        "orderNumber",
        "supplierName",
        "orderDate",
        "deliveryDate",
        "supplierOrderNumber",
        "label",
        "purchaseOrderStatusId",
      ],
      columns: [
        {
          name: "orderNumber",
          align: "left",
          label: "Ordre nr",
          field: "orderNumber",
          sortable: true,
        },

        {
          name: "supplierName",
          align: "left",
          label: "Leverandør navn",
          field: "supplierName",
          sortable: true,
        },

        {
          name: "orderDate",
          align: "left",
          label: "Ord.Dato",
          field: "orderDate",
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
        {
          name: "deliveryDate",
          align: "left",
          label: "Lev.Dato",
          field: "deliveryDate",
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
        {
          name: "supplierOrderNumber",
          align: "left",
          label: "Lev. ordre nr",
          field: "supplierOrderNumber",
          sortable: true,
        },
        {
          name: "label",
          align: "left",
          label: "Merket",
          field: "label",
          sortable: true,
        },
        {
          name: "purchaseOrderStatusId",
          align: "left",
          label: "Ordre status",
          field: "purchaseOrderStatusId",
          format: (val) => this.$t("purchaseOrder.status-" + val),
          sortable: true,
        },
      ],
      columnsOrderLine: [
        {
          name: "productNumber",
          align: "left",
          label: "Produktnummer",
          field: (row) => row.productNumber,
          sortable: true,
        },
        {
          name: "supplierProductNumber",
          align: "left",
          label: "Lev.Produktnummer",
          field: (row) => row.supplierProductNumber,
          sortable: true,
        },
        {
          name: "productName",
          align: "left",
          label: "Produktnavn",
          field: (row) => row.productName,
          sortable: true,
        },
        {
          name: "quantity",
          align: "left",
          label: "Antall",
          field: (row) => row.numberOfItems,
          sortable: true,
        },
        {
          name: "received",
          align: "left",
          label: "Mottatt",
          field: (row) => row.received,
          sortable: true,
        },
        {
          name: "deliveryDate",
          align: "left",
          label: "Lev.Dato",
          field: (row) => row.deliveryDate,
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
      ],
      countOfOrderStatusChars: 0,
    };
  },
  async created() {
    this.initVisibleColumns();
  },
  async mounted() {
    if (this.isRecevingMode) {
      this.disableNewPurchase = true;
      this.orderOptions = [
        { value: 300, name: this.$t("purchaseOrder.status-300") },
        { value: 400, name: this.$t("purchaseOrder.status-400") },
        { value: 500, name: this.$t("purchaseOrder.status-500") },
        { value: 600, name: this.$t("purchaseOrder.status-600") },
      ];

      this.title = this.$t("headers.receiveOrder");
    }
    this.initVisibleOrderStatuses();
    
    
    await this.refresh();
  },

  computed: {
    isRecevingMode() {
      return this.$route.name === "PurchasesReceive";
    },
    ...mapState("main", ["departments"]),

    orderStatusDisplaySelected() {
      let result = "";

      for (let i = 0; i < this.orderStatuses.length; i++) {
        const orderStatusString = "purchaseOrder.status-" + this.orderStatuses[i];

        if (!this.$t(orderStatusString)) continue;
        result += this.$t(orderStatusString) + ", ";
      }

      result = result.slice(0, -2);

      if (this.countOfOrderStatusChars > 130) {
        result += "...";
      } 

      result

      return result;
    }
  },

  watch: {
    async filter(newValue, oldValue) {
      if (newValue != oldValue) {
        clearTimeout(this.timerId);
        this.timerId = setTimeout(this.refresh, 2000);
      }
    },

    orderStatuses(newValue, oldValue) {
      if (newValue != oldValue) {
        const notif = this.$q.notify({
          type: "ongoing",
          message: "Lagrer filter...",
        });
        setTimeout(() => {
          notif();
        }, 500);
        clearTimeout(this.timerId);
        this.timerId = setTimeout(this.filterStatuses, 1000);
      }

      let countOfChars = 0;
      for (let i = 0; i < this.orderStatuses.length; i++) {
        const orderValue = this.orderStatuses[i];
        const orderStatusString = "order.status-" + orderValue;

        countOfChars += this.$t(orderStatusString).length;
      }
      this.countOfOrderStatusChars = countOfChars;

      let visibleCount = 0;
      let runningLength = 0;
      for (const orderStatus of this.orderStatuses) {
        const orderStatusName = "order.status-" + orderStatus

        if (!this.$t(orderStatusName)) continue;
        if (runningLength + this.$t(orderStatusName).length > 130) break;
        runningLength += this.$t(orderStatusName).length;
        visibleCount++;
      }
      this.numberOfSelectedOrderStatusesThatAreDisplayed = visibleCount;
    },

    isRecevingMode(newValue, oldValue) {
      if (newValue != oldValue) {
        if (this.isRecevingMode) {
          this.disableNewPurchase = true;
          this.orderOptions = [
            { value: 300, name: this.$t("purchaseOrder.status-300") },
            { value: 400, name: this.$t("purchaseOrder.status-400") },
            { value: 500, name: this.$t("purchaseOrder.status-500") },
            { value: 600, name: this.$t("purchaseOrder.status-600") },
          ];

          var cookieStatusRecieve = this.$cookies.get("purchaseRecieveStatusFilter");
          if (cookieStatusRecieve) {
            var columnsRecieve = [];
            cookieStatusRecieve.split(",").forEach(function(col) {
              columnsRecieve.push(Number(col));
            });
            
            this.orderStatuses = columnsRecieve;
          }


          this.title = this.$t("headers.receiveOrder");
          this.refresh();
        } else {
          this.orderOptions = [
            { value: 100, name: this.$t("purchaseOrder.status-100") },
            { value: 200, name: this.$t("purchaseOrder.status-200") },
            { value: 300, name: this.$t("purchaseOrder.status-300") },
            { value: 400, name: this.$t("purchaseOrder.status-400") },
            { value: 500, name: this.$t("purchaseOrder.status-500") },
            { value: 600, name: this.$t("purchaseOrder.status-600") },
            { value: 700, name: this.$t("purchaseOrder.status-700") },
          ];
          var cookieStatus = this.$cookies.get("purchaseOrderStatusFilter");
          if (cookieStatus) {
            var columns = [];
            cookieStatus.split(",").forEach(function(col) {
              columns.push(Number(col));
            });
            
            this.orderStatuses = columns;
          }
          this.disableNewPurchase = false;
          this.title = this.$t("headers.purchaseOrder");
          this.refresh();
        }
      }
    },
  },
  methods: {
    openOrder(orderId) {
      if (this.isRecevingMode) {
        router.push({ name: "PurchaseReceive", params: { id: orderId } });
      } else {
        router.push({ name: "Purchase", params: { id: orderId } });
      }
    },

    enterCheck(event) {
      if (event.key === 'Enter' && this.filter != "") {
        var order = this.orders.filter(x => x.orderNumber == this.filter);
        if(order[0].id != undefined) {
          this.openOrder(order[0].id)
        }
      }
    },

    newPurchase() {
      router.push({ name: "Purchase", params: { id: 0 } });
    },

    filterStatuses() {
      this.refresh();
      if (!this.isRecevingMode) {
        this.$cookies.set(
          "purchaseOrderStatusFilter",
          this.orderStatuses.join(","),
          "1Y"
        );
      }
      if (this.isRecevingMode) {
        this.$cookies.set(
          "purchaseRecieveStatusFilter",
          this.orderStatuses.join(","),
          "1Y"
        );
      }
    },

    initVisibleOrderStatuses() {
      if (!this.isRecevingMode) {
        var cookieStatus = this.$cookies.get("purchaseOrderStatusFilter");
        if (cookieStatus) {
          var columns = [];
          cookieStatus.split(",").forEach(function(col) {
            columns.push(Number(col));
          });
        
          this.orderStatuses = columns;
        }
      }
      if (this.isRecevingMode) {
        var cookieStatusRecieve = this.$cookies.get("purchaseRecieveStatusFilter");
        if (cookieStatusRecieve) {
          var columnsRecieve = [];
          cookieStatusRecieve.split(",").forEach(function(col) {
            columnsRecieve.push(Number(col));
          });
        
          this.orderStatuses = columnsRecieve;
        }
      }
    },

    onVisibleColumnsChange() {
      if (this.isRecevingMode)
        this.$cookies.set(
          "purchaseOrdersRecieveColumns",
          this.visibleColumns.join(","),
          "1Y"
        );
      else
        this.$cookies.set(
          "purchaseOrdersColumns",
          this.visibleColumns.join(","),
          "1Y"
        );
    },

    initVisibleColumns() {
      var cookieColums = this.$cookies.get("purchaseOrdersColumns");
      if (this.isRecevingMode)
        cookieColums = this.$cookies.get("purchaseOrdersRecieveColumns");

      if (cookieColums) {
        var columns = [];
        cookieColums.split(",").forEach(function (col) {
          columns.push(col);
        });
        this.visibleColumns = columns;
      }
    },

    async refresh() {
      this.disableFilters = true;

      this.unfilteredOrders = [];
      this.orders = [];

      if (this.orderStatuses.length < 1) {
        this.nodatalabel = "Ingen ordre å vise. Velg én eller flere statuser for å se ordre.";
        this.disableFilters = false;
        return;
      }

      const notif = this.$q.notify({
        type: "ongoing",
        message: "Laster data...",
      });

      const payload = {
        pageNumber: this.pagination.page,
        pageSize: this.pagination.rowsPerPage,
        sortBy: this.pagination.sortBy,
        sortDescending: this.pagination.descending,
        searchQuery: this.filter,
        statuses: this.orderStatuses,
      };

      try {
        const data = await this.getPurchaseOrdersByStatuses(payload);
        this.unfilteredOrders = data.items;
        this.orders = this.unfilteredOrders;
        this.pagination.rowsNumber = data.totalCount;
      } catch (error) {
        console.error("Error fetching orders:", error);
        this.$q.notify({
          type: "negative",
          message: this.$t("common.errorFetchingData")
        });
      }

      setTimeout(() => {
        notif();
      }, 500);

      this.disableFilters = false;
    },

    onRequest(params) {
      if (this.isLoading) return;
      Object.assign(this.pagination, params.pagination);
      this.refresh();
    },

    ...mapActions("main", ["getPurchaseOrders", "getPurchaseOrdersByStatuses"]),
  },
};
